const trimTrailingSlash = (value) => {
  if (!value) return "";
  return value.replace(/\/+$/, "");
};

const runtimeApiBase = process.env.VUE_APP_API_BASE_URL;

// 默认走 Nginx 反向代理：
// 浏览器请求 /api/news
// Nginx 转发到 http://127.0.0.1:8000/news
const API_BASE = trimTrailingSlash(runtimeApiBase || "/api");

export default API_BASE;


// WEBPACK FOOTER //
// ./src/config/api.js